module.exports = __webpack_public_path__ + "static/media/503.307169e4.webp";